import React from 'react';
import { Layout } from 'src/ui/app';
import ZombiePurgeView from 'src/ui/views/ZombiePurge/ZombiePurgeView';
import { useRouter } from 'next/router';
import { SHOW_ZOMBIE_PURGE } from 'src/config';
import useWallet from 'src/hooks/useWallet';
import useNetwork from 'src/hooks/useNetwork';
import useProvider from 'src/hooks/useProvider';
import FeatureFlagGuard from 'src/ui/util/FeatureFlagGuard';

const ZombiePurgeLayout = ( props ) => {
	const router = useRouter();
	const [connect, address] = useWallet();
	const { network } = useNetwork();
	const provider = useProvider();
	const viewPurged = router.query.viewPurged === 'true';


	const zombiePurgeProps = {
		connect, address, network, provider,
	};

	return (
		<Layout
			footerVariation="secondary"
		>
			<FeatureFlagGuard featureFlag={SHOW_ZOMBIE_PURGE}
				address={address}>
				<ZombiePurgeView {...props.pageProps}
					viewPurged={viewPurged}
					{...zombiePurgeProps} />
			</FeatureFlagGuard>

		</Layout>
	);
};

export default function ZombiePurge( props ) {
	return (
		<ZombiePurgeView {...props} />
	);
}

ZombiePurge.Layout = ZombiePurgeLayout;
